// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint[data-v-348882b2]{font-size:.75rem;line-height:1.2}.choice-text[data-v-348882b2]{font-size:.875rem;line-height:1.2;margin:20px 0 40px;flex-grow:1}", ""]);
// Exports
module.exports = exports;
